export default __webpack_public_path__ + "static/media/duplicate.c5b9ff5d.svg";